import { Mail, Phone } from "lucide-react";
import React from "react";

function ContactFooter() {
  return (
    <div className="bg-[#007F38] text-white py-6 sm:py-8 px-4 sm:px-5 lg:px-20">
      <div className="max-w-7xl mx-auto flex flex-col gap-3">
        <div className="text-[16px] sm:text-lg md:text-xl lg:text-2xl">
          Let&apos;s connect!
        </div>
        <div className="flex flex-col sm:flex-row sm:justify-start sm:items-start gap-6 sm:gap-12 mb-6">
          {/* Phone */}
          <div className="flex items-center gap-3 hover:text-emerald-50 transition-colors">
            <Phone size={20} className="flex-shrink-0" />
            <div className="flex flex-col">
              <span className="text-xs text-emerald-100 uppercase tracking-wide">
                Phone
              </span>
              <span className="text-sm sm:text-base text-white">
                +91 7973 938 627
              </span>
            </div>
          </div>

          {/* Email */}
          <div className="flex items-center gap-3 hover:text-emerald-50 transition-colors">
            <Mail size={20} className="flex-shrink-0" />
            <div className="flex flex-col">
              <span className="text-xs text-emerald-100 uppercase tracking-wide">
                Email
              </span>
              <a
                href="mailto:ceo@thefuture.university"
                className="text-sm sm:text-base text-white hover:underline break-all"
              >
                ceo@thefuture.university
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="h-36 sm:h-24" />
    </div>
  );
}

export default ContactFooter;
